import React, { useState, useEffect } from "react";
import { Container, Navbar, Nav, Offcanvas, Image } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import WhiteLogo from "../assets/images/SEtransparentWhite.png";
import Footer from "./Footer";
import { useAuth } from "../hooks/useAuth";
import "./navbar/Navbar.css";

export default function MainLayout(props) {
  const { children } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [showSidebar, setShowSidebar] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { currentUser, logout } = useAuth();

  // Handle navbar scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const currentRoute = location.pathname.replace("/", "");

  const handleNavButtonClick = (location) => {
    if (location === "logout") {
      logout();
      navigate("/");
      return;
    }
    navigate(`/${location}`);
  };

  const isCurrentRoute = (route) => {
    if (route === "") return false;
    return route.toLowerCase() === currentRoute.toLowerCase();
  };

  const navLinks = [
    { text: "Home", path: "" },
    { text: "Services", path: "services" },
    { text: "Events", path: "events" },
    { text: "Meet The Team", path: "meet-the-team" },
    // { text: "Gallery", path: "gallery" },
    { text: "Reviews", path: "reviews" },
    { text: currentUser ? "Admin" : "Login", path: "admin/dashboard" },
  ];

  if (currentUser) {
    navLinks.push({ text: "Logout", path: "logout" });
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Modern Navbar */}
      <Navbar
        variant="dark"
        expand="sm"
        fixed="top"
        className={`modern-navbar ${scrolled ? 'scrolled' : ''}`}
      >
        <Container fluid>
          {/* Logo */}
          <Navbar.Brand className="navbar-logo-container">
            <Link to="/">
              <Image
                src={WhiteLogo}
                alt="The Style Emporium Logo"
                className="navbar-logo"
              />
            </Link>
          </Navbar.Brand>

          {/* Mobile Toggle */}
          <Navbar.Toggle
            aria-controls="navbar-nav"
            onClick={() => setShowSidebar(!showSidebar)}
            className="mobile-toggle"
          />

          {/* Desktop Navigation */}
          <div className="d-none d-sm-block ms-auto">
            <Nav className="desktop-nav">
              {navLinks.map((link) => (
                <Nav.Link
                  key={link.path}
                  onClick={() => handleNavButtonClick(link.path)}
                  className={`nav-link-modern ${isCurrentRoute(link.path) ? 'active' : ''}`}
                >
                  {link.text}
                </Nav.Link>
              ))}
            </Nav>
          </div>
        </Container>
      </Navbar>

      {/* Modern Mobile Sidebar */}
      <Offcanvas
        show={showSidebar}
        onHide={() => setShowSidebar(false)}
        placement="end"
        className="d-sm-none mobile-sidebar"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Navigation</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column align-items-stretch">
          {navLinks.map((link) => (
            <Nav.Link
              key={link.path}
              className={`mobile-nav-link ${isCurrentRoute(link.path) ? 'active' : ''}`}
              onClick={() => {
                handleNavButtonClick(link.path);
                setShowSidebar(false);
              }}
            >
              {link.text}
            </Nav.Link>
          ))}
        </Offcanvas.Body>
      </Offcanvas>

      {/* Main Content */}
      <main className="flex-grow-1 pt-5 mt-5">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
